import { Component, Input } from '@angular/core';
import { ProcessoConsulta } from '@app/models/processo.model';

@Component({
  selector: 'app-tabela-processos',
  templateUrl: './tabela-processos.component.html'
})
export class TabelaProcessosComponent {
  @Input() listaProcessos: ProcessoConsulta[] = [];
}
